import PaymentHelper from "@/utils/payment-helper";

export default class PayPal {
  static get(pm, paymentData, store) {
    switch (pm.type) {
      case "venmo":
        return PayPal.venmoCheckout(store);
    }
  }

  static venmoCheckout(store) {
    const { first_name, last_name, email, phone } = store.state.customer.data;
    return {
      customer: {
        firstName: first_name,
        lastName: last_name,
        email: email,
        phone: phone,
        billingAddress: PaymentHelper.getCustomerBillingAddress(store)
      },
      funding: {
        disallowed: [
          "sofort",
          "sepa",
          "p24",
          "mybank",
          "mercadopago",
          "ideal",
          "giropay",
          "eps",
          "blik",
          "bancontact",
          "paylater",
          "credit",
          "card"
        ]
      }
    };
  }
}
